<template>
  <div class="row pt-3">
    <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
      <h3 class="serif">
        <strong>
          <slot name="title"></slot>
        </strong>
      </h3>
      <div class="mx-5 mt-3 mb-5 border-top border-bottom">
        <span class="lh text-uppercase">
          <slot name="category"></slot>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-header',
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/rows/PageHeader.vue